import DelegateModal from './DelegateModal';
export default DelegateModal;
